import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router';
// import LogoImg from 'assets/img/logo_po.svg';
import LogoBetaImg from 'assets/img/logo_po_beta.svg';

export default function Logo() {
  return (
    <LogoBase to={'/'}>
      {/* <LogoImg /> */}
      <img src={LogoBetaImg} alt="DataInsight Logo" />
    </LogoBase>
  );
}

const LogoBase = styled(Link)`
  min-width: 322px; // NOTE: as-is 263px
  height: 25px;
  object-fit: contain;
  margin-right: 40px;
`;
